
	import {
		Component,
		Vue
	} from 'vue-property-decorator';
	import PageFooter from '@/components/page-footer.vue'
	import PickerDate from '@/components/picker-date.vue';
  import Dialog from '@/components/dialog.vue';
	import {
    productRepeatGroupApplyRecord,
    productRepeatGroup,
	} from '@/api/statistic'
  import {
		productfilterBoxList,
	} from '@/api/supplier';
	import {
		getSearchDate,
		nextDay
	} from "@/utils/index"
	@Component({
		name: 'product-sales',
		components: {
			PageFooter,
			PickerDate,
      'slz-dialog': Dialog,
		}
	})
	export default class ProductSales extends Vue {
		private filterTime:any = ''
		private shopkey = ''
		private namekey = ''
		private list: any = []
		private pageNo = 1;
		private pageSize = 10;
		private total = 0;
		private tableloading = false
		private lazyloading = false
    private applyShow = false
    private rowmsg:any = {}
    private shoplist:any = []
    private sendmsg:any = {}

		// private activated () {
		// 	this.initTime()
		// 	// console.log(getSearchDate(2,false,-6),getSearchDate(2))
		// 	this.getList();
		// }

		mounted () {
      this.initTime()
			this.getList();
			
		}


    private cancel(){
      this.applyShow = false
      this.sendmsg = {}
    }

    private getname(e){
      // console.log(this.shoplist.find(v=>v.Id==e)?.ProductName)
      this.sendmsg.ProductName = this.shoplist.find(v=>v.Id==e)?.ProductName
    }

    private async confirmsend(){
      if(!this.sendmsg.ProductId){
        this.$message.error('请选择商品')
        return 
      }else if(!this.sendmsg.Remark){
        this.$message.error('请输入备注内容')
        return 
      }else if(!this.sendmsg.OpenTime){
        this.$message.error('请完善上架时间')
        return 
      }
      try{
        let data = this.sendmsg
        data.ProductId = this.rowmsg.ProductId
        let res = await productRepeatGroup(data)
        if(res.IsSuccess){
          this.$message.success('已发送复团通知')
          this.cancel()
          this.getList()
        }
      }finally{
        //
      }
    }

    protected nowtime(){
      let date = new Date()
      const year = date.getFullYear()
      const month = date.getMonth()+1>9?date.getMonth()+1:'0'+(date.getMonth()+1)
      const day = date.getDate()>9?date.getDate():'0'+date.getDate()
      const hour = date.getHours()>9?date.getHours():'0'+date.getHours()
      const min = date.getMinutes()>9?date.getMinutes():'0'+date.getMinutes()
      const sec = date.getSeconds()>9?date.getSeconds():'0'+date.getSeconds()
      return [year,month,day].join('-')
      // +' '+[hour,min,sec].join(':')
    }

    private async getshoplist(){
      try{
        let params:any = {
					Skip: 0,
					Take: 999999,
					Keywords: '',
					ProviderName: '',
					ProductCategoryId: '',
          IsOpen:'',
          StartTime:'',
          EndTime:''
				}
        const res: any = await productfilterBoxList(params);
        this.shoplist = res.Result;
        let shop = this.shoplist.find(v=>v.Id==this.rowmsg.ProductId)
        // console.log(shop)
        if(!shop||!shop.Id){
          this.shoplist.unshift({
            Id:this.rowmsg.ProductId,
            ProductName:this.rowmsg.ProductName
          })
        }
        // console.log(!this.shoplist.find(v=>v.Id==this.rowmsg.ProductId)?.ProductId,this.shoplist)
      }finally{
        //
      }
    }

    private sendnotice(row){
      this.rowmsg = row
      this.applyShow = true
      this.sendmsg = {
        ProductId:row.ProductId,
        ProductName:row.ProductName,
        Remark:'商品已复团，点击立即购买',
        OpenTime:getSearchDate(2)[0],
      }
      this.getshoplist()
    }

		private initTime(){
      let date = new Date()
      let day = date.getDay()
			this.filterTime = [nextDay(getSearchDate(2)[0],1-day),nextDay(getSearchDate(2)[0],1)].join('/')
		}


		private changePage(num: number) {
			this.pageNo = num;
			this.getList();
		}

		private exportlist(){
			let url = location.origin + '/pc/product/productRepeatGroupApplyRecordExport' + 
								'?Keywords=' + (this.shopkey?this.shopkey:'') +
								'&ProviderName=' + (this.namekey?this.namekey:'')

								if (this.filterTime) {
                  let time = this.filterTime.split('/')
									url += '&StartTime=' + (time[0]?time[0]:'')
									url += '&EndTime=' + (time[1]?nextDay(time[1],1):'');
								}
			// console.log(url)
			window.open(url)
		}

		private async getList() {
			let params: any = {
				Skip: (this.pageNo-1)*this.pageSize,
				Take: this.pageSize,
				Keywords: this.shopkey,
				ProviderName: this.namekey,
			}
			if (this.filterTime) {
        let time = this.filterTime.split('/')
				params.StartTime = time[0]
				params.EndTime = nextDay(time[1],1)
			}
			this.tableloading = true
			try {
				const res: any = await productRepeatGroupApplyRecord(params);
				// console.log(res)
				this.list = res.Result.Results.map(v=>{
          v.RepeatNoticeProductOpenTime = v.RepeatNoticeProductOpenTime&&v.RepeatNoticeProductOpenTime.substring(0,10)
          return v
        })
				this.total = res.Result.Total;
				// console.log(this.list)
			} catch (e) {
				console.log(e)
			} finally{
				this.tableloading = false
			}
		}

		private doSearch() {
			this.pageNo = 1;
			this.getList();
		}

		private clearSearch() {
			this.filterTime = ''
			this.shopkey = '';
			this.namekey = '';
			this.getList();
		}
	}
